import { EmploymentType } from "../models";

export const DIFF_HOURS_WARNING = 17;

/** Pure helper — kept out of WarningDialog.tsx so logic/util modules can use it without pulling the
 * dialog (and its context dependencies) into their import graph. */
export const isAgencyNurse = (employmentType: EmploymentType): boolean => {
	return employmentType === EmploymentType.Travel || employmentType === EmploymentType.PerDiem;
};
